import {
  Box,
  Flex,
  HStack,
  Image,
  Text,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import { useParams } from "react-router-dom";
import DashboardHeader from "../../../components/common/DashboardHeader";
import TraineeSidenav from "../../../components/trainee/courses/Sidenav";
import rarrow from "../../../img/rarrow.svg";
import { getLocalUserProfile } from "../../../services/auth.service";
import coursesService from "../../../services/courses.service";
import calendarService from "../../../services/trainer/calendar.service";
import { getNexMonth, getPreviousMonth } from "../../../utils/dates";
import TraineeMobileNav from "../../../components/common/TraineeMobileNav";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const events = [
  {
    title: "NAPTIN Meeting",
    allDay: true,
    start: new Date(2022, 8, 26),
    end: new Date(2022, 8, 26),
  },
  {
    title: "Conference",
    start: new Date(2022, 8, 26),
    end: new Date(2022, 8, 26),
  },
  {
    title: "Vacattion",
    start: new Date(2022, 9, 26),
    end: new Date(2022, 9, 26),
  },
];

const CourseCalendar = () => {
  const { course_id } = useParams();
  const [allEvents, setAllevents] = useState<any[]>();
  const [reload, setReload] = useState(false);
  const courseName: null | string = localStorage.getItem("courseName");
  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });

  useEffect(() => {
    const user = getLocalUserProfile();
    if (user) {
      const date = new Date();
      calendarService
        .getCalendar(user.id, getPreviousMonth(date), getNexMonth(date))
        .then((res) => {
          const events: any[] = [];
          res.data.forEach((each) => {
            const date = new Date(each.event_datetime);
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const end_date = new Date(each.event_end_datetime);
            const end_year = end_date.getFullYear();
            const end_month = end_date.getMonth();
            const end_day = end_date.getDate();
            const end_hour = end_date.getHours();
            const end_minute = end_date.getMinutes();
            const event_data: any = {
              title: each.event,
              start: new Date(year, month, day, hour, minute, 0),
              end: new Date(
                end_year,
                end_month,
                end_day,
                end_hour,
                end_minute,
                0
              ),
              desc: each.event_description,
            };
            events.push(event_data);
          });
          // setAllevents(events);
        });

      coursesService
        .getAvailableCourses()
        .then((response) => {
          const realCourses = response.filter((each) => each.course !== null);

          const available_course = realCourses.find(
            (each) => each.course.uuid == course_id
          );

          if (available_course) {
            const date = new Date();
            calendarService
              .getCourseCalendar(
                available_course?.course.id,
                getPreviousMonth(date),
                getNexMonth(date)
              )
              .then((res) => {
                const events: any[] = [];
                res.data.forEach((each) => {
                  const date = new Date(each.event_datetime);
                  const year = date.getFullYear();
                  const month = date.getMonth();
                  const day = date.getDate();
                  const hour = date.getHours();
                  const minute = date.getMinutes();
                  const end_date = new Date(each.event_end_datetime);
                  const end_year = end_date.getFullYear();
                  const end_month = end_date.getMonth();
                  const end_day = end_date.getDate();
                  const end_hour = end_date.getHours();
                  const end_minute = end_date.getMinutes();
                  const event_data: any = {
                    title: each.event,
                    start: new Date(year, month, day, hour, minute, 0),
                    end: new Date(
                      end_year,
                      end_month,
                      end_day,
                      end_hour,
                      end_minute,
                      0
                    ),
                    desc: each.event_description,
                  };
                  events.push(event_data);
                });
                setAllevents(events);
              });

            // setAvailableCourses(available_course);
          }
        })
        .catch((err) => err);
    }
  }, [reload]);

  return (
    <>
      <DashboardHeader />
      <Box
        bg="#F9F8F8"
        minHeight={"100vh"}
        height="auto"
        width="100%"
        pt={"1.5rem"}
      >
        {!showSideNav && <TraineeMobileNav courseId={course_id || ""} />}
        <Flex
          width="90%"
          mx="auto"
          pb="120px"
          pt={["50px", "60px", "60px", "80px"]}
        >
          {showSideNav && <TraineeSidenav />}

          <VStack
            width={{ lg: "80%", md: "70%", sm: "95%", base: "95%" }}
            mx="auto"
          >
            <HStack width={"100%"} height={"2rem"}>
              <Text
                as="span"
                fontSize={["16px", "20px"]}
                isTruncated
                maxWidth={["180px", "200px", "350px", "500px"]}
              >
                {courseName && courseName.replaceAll(/"/g, "")}
              </Text>
              <Image src={rarrow} />
              <Text
                as="span"
                fontSize={["16px", "16px", "18px", "20px"]}
                color={"#616161"}
              >
                Event Scheduler
              </Text>
            </HStack>
            <Box width="100%">
              <Box
                width="100%"
                mx="auto"
                pb={{
                  lg: "200px",
                  md: "150px",
                  sm: "110px",
                  base: "110px",
                }}
                px={{
                  lg: "2.8rem",
                  md: "2.4rem",
                  sm: "2rem",
                  base: "1.4rem",
                }}
                pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                bg="white"
              >
                <Text
                  color="#1E1E1E"
                  fontSize={{
                    lg: "28px",
                    md: "20px",
                    sm: "18px",
                    base: "18px",
                  }}
                  pb={["20px", "30px"]}
                  fontWeight="600"
                >
                  Event Scheduler
                </Text>
                <Calendar
                  localizer={localizer}
                  events={allEvents}
                  eventPropGetter={(allEvents: any) => {
                    const backgroundColor = "#EC3337";
                    const color = "white";
                    const overflowX = "scroll";
                    return { style: { backgroundColor, color, overflowX } };
                  }}
                  startAccessor="start"
                  endAccessor="end"
                  style={{ height: 500 }}
                />
              </Box>
            </Box>
          </VStack>
        </Flex>
      </Box>
    </>
  );
};

export default CourseCalendar;
